import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'

import { ButtonComponent } from '../button/button.component'

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    RouterLink,
    TranslatePipe,
    SvgIconComponent,
  ],
  templateUrl: 'back-button.component.html',
})
export class BackButtonComponent {
  @Input({ required: false }) public text?: string
  @Input({ required: false }) public route: string | string[] = '../../'

  public constructor() {}
}
